import { render, staticRenderFns } from "./ErrorMsg.vue?vue&type=template&id=0f7a9011&"
import script from "./ErrorMsg.vue?vue&type=script&lang=js&"
export * from "./ErrorMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports